export enum CMSHeader {
  PLATFORM_LOCALE_HEADER = 'platform-locale',
}
